import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class NewsTitle extends PureComponent {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number]),
    };

    render() {
        const { children } = this.props;

        return (
            <div className={styles.bigTitleBox}>
                <h4 className={styles.bigTitle}>{children}</h4>
                <span className={styles.lengLeft} />
                <span className={styles.lengRight} />
            </div>
        );
    }
}

export default NewsTitle;
